import { ServicesUseCase } from '../../../data/usecases'
import { makeAxiosHttpClient } from '../../factories'

type FetchTestApplicationModel = {
  id: string | number
}

type DeleteTestApplicationModel = {
  idService: string | number
  id: string | number
}

export const fetchTestApplication = ({ id }: FetchTestApplicationModel) => {
  return new ServicesUseCase(`/aplicacaoTeste/new/${id}`, makeAxiosHttpClient())
}

export const saveTestApplication = ({ id }: FetchTestApplicationModel) => {
  return new ServicesUseCase(
    `/aplicacaoTeste/save/${id}`,
    makeAxiosHttpClient()
  )
}

export const deleteTestApplication = ({
  idService,
  id
}: DeleteTestApplicationModel) => {
  return new ServicesUseCase(
    `/aplicacaoTeste/${idService}/deleteBlock/${id}`,
    makeAxiosHttpClient()
  )
}
